module.exports = __webpack_public_path__ + "img/2_03.513e3ab8.jpg";